import { stringifyEntityRef } from '@backstage/catalog-model';
import { ResponseError } from '@backstage/errors';

class TodoClient {
  discoveryApi;
  identityApi;
  constructor(options) {
    this.discoveryApi = options.discoveryApi;
    this.identityApi = options.identityApi;
  }
  async listTodos(options) {
    const { entity, offset, limit, orderBy, filters } = options;
    const baseUrl = await this.discoveryApi.getBaseUrl("todo");
    const { token } = await this.identityApi.getCredentials();
    const query = new URLSearchParams();
    if (entity) {
      query.set("entity", stringifyEntityRef(entity));
    }
    if (typeof offset === "number") {
      query.set("offset", String(offset));
    }
    if (typeof limit === "number") {
      query.set("limit", String(limit));
    }
    if (orderBy) {
      query.set("orderBy", `${orderBy.field}=${orderBy.direction}`);
    }
    if (filters) {
      for (const filter of filters) {
        query.append("filter", `${filter.field}=${filter.value}`);
      }
    }
    const res = await fetch(`${baseUrl}/v1/todos?${query}`, {
      headers: token ? {
        Authorization: `Bearer ${token}`
      } : void 0
    });
    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }
    const data = await res.json();
    return data;
  }
}

export { TodoClient };
//# sourceMappingURL=TodoClient.esm.js.map
